import styled from 'styled-components';

import { dangerHighlightColor, warnHighlightColor } from '../../../lib/theme';

// Covers the editor field; rects are measured relative to this layer's own box,
// so panel scroll moves the layer and editor together with no drift.
export const HighlightLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
`;

// multiply keeps dark glyphs crisp while tinting the light background behind the
// token — a behind-text highlight look without reordering Quill's DOM.
export const HighlightRect = styled.div`
  position: absolute;
  border-radius: 2px;
  mix-blend-mode: multiply;
  background: ${dangerHighlightColor};

  &[data-issue='missing-fallback'] {
    background: ${warnHighlightColor};
  }
`;
